/**
 * StronaHodowliRedirect — resolver pozycji menu „Strona hodowli".
 *
 * Zgodnie z zasadą: profil hodowli jest TWORZONY i ZARZĄDZANY przez Kreator
 * (KennelWizardV2), a nie przez legacy ProfilePanel (zakładki).
 *
 * - Ma hodowlę  → /wizard/hodowla-v2/{id} (edycja).
 * - Brak hodowli → /wizard/hodowla-v2 (nowa).
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';
import StudioShell from '@/components/studio/StudioShell';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StronaHodowliRedirect() {
  const navigate = useNavigate();
  const { token } = useAuth();

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/kennels`, { headers: { Authorization: `Bearer ${token}` } });
        const k = (res.data || [])[0];
        if (!active) return;
        navigate(k?.id ? `/wizard/hodowla-v2/${k.id}` : '/wizard/hodowla-v2', { replace: true });
      } catch {
        if (active) navigate('/wizard/hodowla-v2', { replace: true });
      }
    })();
    return () => { active = false; };
  }, [token, navigate]);

  return (
    <StudioShell mode="workspace" contextLabel="Strona hodowli" activeKey="hodowla">
      <div className="flex items-center justify-center py-40" data-testid="strona-hodowli-redirect">
        <Loader2 className="w-7 h-7 animate-spin text-orange-500" />
      </div>
    </StudioShell>
  );
}
